import { useTimeout } from "@/hooks/useTimeout";
import { CopyCheckIcon, CopyIcon } from "lucide-react";
import { ComponentProps, useState } from "react";
import { IconButton } from "../Button/IconButton";
import { Button } from "../Button";
import { cn } from "cn";

export function CopyButton({
  iconClassName,
  ...props
}: ComponentProps<typeof Button> & {
  iconClassName?: string;
}) {
  const [copied, setCopied] = useState(false);

  useTimeout(
    () => {
      setCopied(false);
    },
    copied ? 2000 : null,
  );

  return (
    <Button
      {...props}
      onClick={(e) => {
        setCopied(true);
        props.onClick?.(e);
      }}
      icon={
        copied ? (
          <CopyCheckIcon className={cn(iconClassName)} />
        ) : (
          <CopyIcon className={cn(iconClassName)} />
        )
      }
    >
      {props.children}
    </Button>
  );
}

export function CopyIconButton(
  props: Omit<ComponentProps<typeof IconButton>, "icon">,
) {
  const [copied, setCopied] = useState(false);

  useTimeout(
    () => {
      setCopied(false);
    },
    copied ? 2000 : null,
  );

  return (
    <IconButton
      {...props}
      onClick={(e) => {
        setCopied(true);
        props.onClick?.(e);
      }}
      icon={copied ? <CopyCheckIcon /> : <CopyIcon />}
    />
  );
}
